<template>
  <div>
    <v-card-text>
      <v-switch
        :label="`${$t('schema.builder.inputs.options.required')}`"
        :input-value="options.required"
        @change="update({required: $event})"
      ></v-switch>
      <v-text-field
        type="number"
        :label="`${$t('schema.builder.inputs.options.min-results')}`"
        step=1
        :value="options.minResults"
        @change="update({minResults: $event})">
      ></v-text-field>
      <v-text-field
        type="number"
        :label="`${$t('schema.builder.inputs.options.max-results')}`"
        step=1
        :value="options.maxResults"
        @change="update({maxResults: $event})">
      ></v-text-field>
    </v-card-text>
  </div>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "multiple-options",
  mixins: [ options ],
  computed: {
    kinds() {
      return [
        {
          name: this.$t('schema.builder.inputs.options.kind.text'),
          value: 'text'
        },
        {
          name: this.$t('schema.builder.inputs.options.kind.number'),
          value: 'number'
        }
      ]
    }
  }
}
</script>
<style>
</style>
